import { render, staticRenderFns } from "./CreateOrEditScoring.vue?vue&type=template&id=13a28c37&scoped=true&"
import script from "./CreateOrEditScoring.vue?vue&type=script&lang=js&"
export * from "./CreateOrEditScoring.vue?vue&type=script&lang=js&"
import style0 from "./CreateOrEditScoring.vue?vue&type=style&index=0&id=13a28c37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a28c37",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperHeader } from 'vuetify/lib/components/VStepper';
import { VStepperItems } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
installComponents(component, {VStepper,VStepperHeader,VStepperItems,VStepperStep})
